export default `
  query GuestWishlistItemsCount($guestCustomerId: ID!) {
    guestWishlist(guestCustomerId: $guestCustomerId) {
      items_count
    }
  }
`;
